import { http } from '@/utils/http';
import qs from 'qs';


// 获取地方
export function getLocation(voteName: string) {
  return http.get('/vote/' + voteName + '/controller.php?enews=location');
}
// 获取详情
export function getContent(voteName: string, locationId?: number) {
  return http.get('/vote/' + voteName + '/controller.php?enews=getcontent', {
    params: { locationId },
  });
}

// 获取评论
export function getComment(voteName: string, locationId?: number) {
  return http.get('/vote/' + voteName + '/controller.php?enews=comment', {
    params: { locationId },
  });
}

// 提交评论
export function saveComment(voteName: string, data?: any) {
  const qsData = qs.stringify(data);
  return http.post(
    '/vote/' + voteName + '/controller.php?enews=comment-save',
    qsData,
  );
}
